<template>
  <page-view title="专家抽取申请">
    <template slot="action">
      <a-space size="small">
        <a-button slot="extra" type="primary" icon="save" @click="onSave" :loading="loading">
          提交
        </a-button>
      </a-space>
    </template>
    <a-spin tip="正在加载数据..." :spinning="spinning">
      <a-card class="mb-3">
        <process-selector v-if="false" path="/selectExpertApply/add" @change="onChangeProcess"/>
        <a-form-model ref="applyFormRef" :model="applyForm" :rules="rules" class="exi_form item_100"
                      :label-col="{ flex: '0 0 150px' }" :wrapper-col="{ span: 24 }">
          <a-row :gutter="20">
            <a-col :span="8">
              <a-form-model-item label="项目编号">
                <a-input v-model="applyForm.projectCode" placeholder="项目编号"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="16">
              <a-form-model-item label="项目名称" prop="projectName">
                <a-input v-model="applyForm.projectName" placeholder="项目名称"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="用途" prop="applyType">
                <dict-cascader dict-key="BID_ZJSZYT" style="width: 100%" placeholder="用途"
                               v-model="applyForm.applyType"></dict-cascader>
              </a-form-model-item>
            </a-col>
            <a-col :span="16" v-if="ApplyTypeEnum.OTHER ===applyForm.applyType ">
              <a-form-model-item label="其他用途" prop="applyTypeOther">
                <div class="d-flex">
                  <a-input placeholder="其他用途"
                           v-model="applyForm.applyTypeOther" style="width: 80%"/>
                  <a-popover title="格式要求">
                    <template slot="content">
                      <p>•长度不超过35个字。</p>
                      <p>•不允许填入QQ号、微信号（公众号）</p>
                      <p>、手机和电话号码、网址链接等。</p>
                    </template>
                    <a class="ml-2" style="text-decoration: underline;">
                      格式要求
                    </a>
                  </a-popover>
                </div>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="需抽取人数" prop="expertNumber">
                <a-input-number placeholder="需抽取人数" disabled style="width: 100%"
                                v-model="expertTotalNumber"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="采购方式">
                <dict-cascader placeholder="采购方式" style="width: 100%" dict-key="expert_purchase_method"
                               v-model="applyForm.method"></dict-cascader>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="20">
            <a-col :span="8">
              <a-form-model-item :label="getApplyTypeLabel"
                                 prop="openDate"   :rules="{required: ApplyTypeEnum.PROJECT_REVIEW === this.applyForm.applyType, message: `请选择${getApplyTypeLabel}`, trigger: 'change'}">
                <a-date-picker v-model="applyForm.openDate" format="YYYY-MM-DD HH:mm" :show-time="timeStep"
                               @change=" applyForm.setOfTime && $refs.applyFormRef.validateField('setOfTime')"
                               style="width: 100%"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="预计时长" prop="reviewDuration">
                <a-input v-model="applyForm.reviewDuration" placeholder="例：4小时或2天"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="专家年龄限制" prop="expertAge">
                <div class="d-flex">
                  <a-input-number placeholder="年龄限制"
                                  :min="1" :max="100" :precision="0" v-model="applyForm.expertAge" style="width: 70%"/>
                  <div class="ml-2">
                    岁以下
                  </div>
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="20">
            <a-col :span="8">
              <a-form-model-item label="集合时间" prop="setOfTime">
                <template #help><span style="color: #b7a51ad6">{{ setOfTimeTips }}</span></template>
                <a-date-picker v-model="applyForm.setOfTime" :format="'YYYY-MM-DD HH:mm'"
                               :show-time="timeStep"
                               style="width: 100%"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="16">
              <a-form-model-item label="集合地点" prop="setOfAddress">
                <div class="d-flex">
                  <a-textarea placeholder="集合地点" v-model="applyForm.setOfAddress"
                              :auto-size="{ minRows: 1, maxRows: 5 }" style="width: 85%"/>
                  <a-popover title="格式要求">
                    <template slot="content">
                      <p>•长度不超过30个字。</p>
                      <p>•仅支持简体中文、数字、英文字母以及常用字符。</p>
                      <p>•不支持全英文地址。</p>
                      <p>•勿输入QQ号、微信号。</p>
                    </template>
                    <a class="ml-2" style="text-decoration: underline;">
                      格式要求
                    </a>
                  </a-popover>
                </div>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="咨询电话" prop="reviewTelephone">
                <div class="d-flex">
                  <a-input v-model="applyForm.reviewTelephone" placeholder="咨询电话" style="width: 80%"/>
                  <a-popover title="格式要求">
                    <template slot="content">
                      <p>•中国内地标准固话和手机号码。</p>
                      <p>•长度不超过15个字，仅支持5~13位数字</p>
                      <p>和短横线的组合，示例：</p>
                      <p>0571-82123***、400-123-1234、10086、95679</p>
                    </template>
                    <a class="ml-2" style="text-decoration: underline;">
                      格式要求
                    </a>
                  </a-popover>
                </div>
              </a-form-model-item>
            </a-col>
            <a-col :span="16">
              <a-form-model-item label="需携带材料" prop="information">
                <div class="d-flex">
                  <a-textarea placeholder="需携带材料" v-model="applyForm.information"
                              :auto-size="{ minRows: 1, maxRows: 3 }" style="width: 85%"/>
                  <a-popover title="格式要求">
                    <template slot="content">
                      <p>•长度不超过35个字。</p>
                      <p>•不允许填入QQ号、微信号（公众号）</p>
                      <p>、手机和电话号码、网址链接等。</p>
                    </template>
                    <a class="ml-2" style="text-decoration: underline;">
                      格式要求
                    </a>
                  </a-popover>
                </div>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="申请人">
                <a-input v-model="applyForm.applyUserName" placeholder="申请人"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="处理人" prop="processUserId">
                <user-selector placeholder="处理人" @change="onChangeUser" v-model="applyForm.processUserId"
                               style="width: 100%"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="登记时间" prop="addDate">
                <a-date-picker v-model="applyForm.addDate" disabled :format="'YYYY-MM-DD HH:mm'"
                               :show-time="timeStep"
                               style="width: 100%"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>

      </a-card>
      <a-card class="mb-3">
        <template slot="title">
          <b class="mr-3">选择采购品目</b>
        </template>
        <PurchaseForm ref="purchaseRef" :readonlyPurchase="readonlyPurchase" :purchaseForm="purchaseForm"
                      :apply-id="applyForm.id"/>
      </a-card>
      <!--           <---------------------回避专家选择--------------------------------->
      <AvoidExpertUnitForm ref="avoidExpertUnitRef" :avoidExpertUnitForm="avoidExpertUnitForm"/>
      <!--           <---------------------回避单位选择--------------------------------->
      <AvoidExpertForm ref="avoidExpertRef" :avoidExpertForm="avoidExpertForm"/>
    </a-spin>
  </page-view>
</template>
<script>
import { PageView } from '@/layouts'
import DictRadio from '@/components/dict/DictRadio'
import DictCheckbox from '@/components/dict/DictCheckbox'
import moment from 'moment'
import ProcessSelector from '@/components/workflow/ProcessSelector'
import UserSelector from '@/components/selector/UserSelector'
import { rules, formWaring, ApplyTypeEnum } from '@/epp/expertmain/selectexpertapply/utils/ExpertApplyUtils'
import PurchaseForm from '@/epp/expertmain/selectexpertapply/common/itemform/PurchaseForm'
import AvoidExpertForm from '@/epp/expertmain/selectexpertapply/common/itemform/AvoidExpertForm'
import AvoidExpertUnitForm from '@/epp/expertmain/selectexpertapply/common/itemform/AvoidExpertUnitForm'
import DictCascader from '@/components/dict/DictCascader.vue'
import {
  GetSelectExpertApplyList,
  AddOrEditSelectExpertApply
} from '@/epp/expertmain/selectexpertapply/api/ExpertApplyRequest'
import { GetListByDto } from '@/epp/sysContentMange/api/sysContentMangeApi'
import {
  ACTION_TYPE,
  CONTENT_KEY_APPLY_ADDRESS,
  CONTENT_KEY_EXPERT_CONSULT_TELEPHONE, CONTENT_TYPE
} from '@/epp/sysContentMange/util/sysContentMangeUtil'
import { IsSysAdmin } from '@/epp/expertmain/userperm/UserPermUtil'
import _ from 'lodash'

export default {
  name: 'SelectExpertApplyForm',
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  components: {
    PageView,
    DictRadio,
    DictCheckbox,
    ProcessSelector,
    UserSelector,
    PurchaseForm,
    AvoidExpertForm,
    AvoidExpertUnitForm,
    DictCascader
  },
  data () {
    const checkTime = (rule, value, callback) => {
      //如果是开标时间
      this.setOfTimeTips = undefined
      let openDate = this.applyForm.openDate && moment(this.applyForm.openDate)
      if (value && openDate) {
        let diff = Math.abs(openDate.diff(value, 'minutes', false))
        if (diff / 60 > 1) {
          this.setOfTimeTips = '集合时间和开标时间差距过大，请检查是否有误。'
        }
        callback()
      } else {
        callback()
      }
    }
    return {
      rules: {
        ...rules,
        setOfTime: [{ required: true, message: '集合时间不能为空！', trigger: 'change' }, {
          validator: checkTime,
          trigger: 'change'
        }],
      },
      timeStep: {
        minuteStep: 30,
        format: 'HH:mm',
        defaultValue: moment('09:00', 'HH:mm')
      },
      user: this.$ls.get('user'),
      applyForm: {
        projectCode: undefined,
        projectName: undefined,
        processUserId: this.$ls.get('user').id,
        processUserName: this.$ls.get('user').name,
        addDate: moment(),
        setOfTime: null,
        expertNumber: undefined,
        reviewTelephone: undefined,
        setOfAddress: undefined,
        reviewDuration: undefined,
        information: '身份证原件',
        applyType: '1',
        openDate: null,
        method: undefined,
        applyTypeOther: undefined,
        expertAge: undefined,
        otherSourceLibrary: []
      },
      purchaseForm: {
        data: []
      },
      avoidExpertForm: {
        data: []
      },
      avoidExpertUnitForm: {
        data: []
      },
      spinning: false,
      loading: false,
      caseTypeId: this.$route.query.caseTypeId,
      procId: '',
      //默认不需要流程
      needWf: false,
      ApplyTypeEnum,
      setOfTimeTips: undefined,
      //抽取记录
      recordList: []
    }
  },
  watch: {
    'applyForm.applyType' (val) {
      if (val && val !== ApplyTypeEnum.OTHER) {
        this.applyForm.applyTypeOther = undefined
      }
    }
  },
  computed: {
    getApplyTypeLabel () {
      return ApplyTypeEnum.PROJECT_REVIEW === this.applyForm.applyType ? '开标时间' : '活动时间'
    },
    expertTotalNumber () {
      let totalNumber = null
      this.purchaseForm.data.forEach(item => {
        if (item.applyNum) {
          totalNumber += item.applyNum
        }
      })
      this.applyForm.expertNumber = totalNumber
      return totalNumber
    },
    //是否显示流程
    isShowWf () {
      return this.needWf
    },
    // 只能查看品目
    readonlyPurchase () {
      return this.recordList.length > 0 && !IsSysAdmin()
    },
  },
  created () {
    this.loadData()
  },
  methods: {
    moment,
    // 选择流程
    onChangeProcess (id, caseTypeId) {
      this.procId = id
      this.caseTypeId = this.caseTypeId || caseTypeId
    },
    // 获取专家申请页面数据
    async loadData () {
      const that = this
      if (!that.id) {
        that.needWf = false
        await that.initDefaultData()
        return
      }
      that.spinning = true
      let res = await GetSelectExpertApplyList(that.id)
      that.spinning = false
      if (res.code !== 200) {
        that.$message.error('数据加载失败！！！')
        return
      }
      if (res.result.expertApply) {
        that.applyForm = res.result.expertApply
        that.recordList = res.result.recordList
        that.applyForm.setOfTime = that.applyForm.setOfTime && moment(that.applyForm.setOfTime)
        that.applyForm.openDate = that.applyForm.openDate && moment(that.applyForm.openDate)
        that.applyForm.addDate = that.applyForm.addDate && moment(that.applyForm.addDate)
        that.purchaseForm.data = res.result.itemList
        that.purchaseForm.data && that.purchaseForm.data.map(item => {
          item.otherSourceLibrary = item.otherSourceLibrary && item.otherSourceLibrary.split(',') || []
        })
        that.avoidExpertForm.data = res.result.avoidList
        that.avoidExpertUnitForm.data = res.result.avoidUnitList
      }
      that.needWf = !res.result.hasWf  //有流程说明页面不需再起流程
      that.applyForm.processUserId = that.applyForm.processUserId || that.user.id
      that.applyForm.processUserName = that.applyForm.processUserName || that.user.name

    },
    // 初始化默认数据
    async initDefaultData () {
      try {
        let dto = {
          contentKey: `${CONTENT_KEY_APPLY_ADDRESS},${CONTENT_KEY_EXPERT_CONSULT_TELEPHONE}`,
          actionType: `${ACTION_TYPE.business}`,
          contentType: `${CONTENT_TYPE.TEXT}`
        }
        let res = await GetListByDto(dto)
        if (res.code === 200 && res.result) {
          let address = res.result.filter(item => item.contentKey === CONTENT_KEY_APPLY_ADDRESS)[0]
          this.applyForm.setOfAddress = address?.contentResource
          let phone = res.result.filter(item => item.contentKey === CONTENT_KEY_EXPERT_CONSULT_TELEPHONE)[0]
          this.applyForm.reviewTelephone = phone?.contentResource
        }
      } catch (e) {
        this.$message.error(e.message)
      } finally {

      }
    },
    //获取选择的用户信息
    onChangeUser (id, name, user) {
      this.applyForm.processUserName = name
    },
    //保存数据
    async saveData () {
      const that = this
      let data = { ...that.applyForm }
      delete data.extras
      data.setOfTime = data.setOfTime && data.setOfTime.format('YYYY-MM-DD HH:mm')
      data.openDate = data.openDate && data.openDate.format('YYYY-MM-DD HH:mm')
      data.addDate = data.addDate && data.addDate.format('YYYY-MM-DD HH:mm')
      //申请信息
      let postData = {}
      postData.selectExpertApply = data
      //品目信息
      postData.selectExpertItemList = _.cloneDeep(that.purchaseForm.data)
      postData.selectExpertItemList.map(item => {
        if (item.otherSourceLibrary && item.otherSourceLibrary.length > 0) {
          item.otherSourceLibrary = item.otherSourceLibrary.join(',')
        }
      })
      //回避专家信息
      postData.expertAvoidanceList = [...that.avoidExpertForm.data]
      //回避单位信息
      postData.expertAvoidUnitList = [...that.avoidExpertUnitForm.data]
      that.loading = true
      let res = await AddOrEditSelectExpertApply(postData)
      that.loading = false
      if (res.code !== 200) {
        that.$message.error('操作失败')
        return
      }
      that.$message.success('操作成功')
      await that.$router.replace({
        path: '/selectExpertApply/view?id=' + res.result
      })
    },
    //保存校验
    onSave () {
      let that = this
      that.$refs.applyFormRef.validate((valid, err) => {
            formWaring(err, valid)
            if (valid) {
              that.$refs.purchaseRef.$refs.purchaseFormRef.validate((valid, err) => {
                formWaring(err, valid)
                if (valid) {
                  if (valid) {
                    that.$refs.avoidExpertRef.$refs.avoidExpertFormRef.validate((valid, err) => {
                      formWaring(err, valid)
                      if (valid) {
                        that.$refs.avoidExpertUnitRef.$refs.avoidExpertUnitFormRef.validate((valid, err) => {
                          formWaring(err, valid)
                          if (valid) {
                            if (that.purchaseForm.data.length === 0) {
                              that.$message.warning('请至少选择一个采购品目')
                              return
                            }
                            const seenCombinations = new Map()
                            for (let i = 0; i < this.purchaseForm.data.length; i++) {
                              const key = `${this.purchaseForm.data[i].address}-${this.purchaseForm.data[i].fspmbm}`
                              if (seenCombinations.has(key)) {
                                that.$message.warning(`采购品目【${this.purchaseForm.data[i].fspmmc}】不能重复`)
                                return
                              }
                              seenCombinations.set(key, this.purchaseForm.data[i])
                            }
                            that.saveData()
                          }
                        })
                      }
                    })
                  }
                }
              })
            }
          }
      )
    },
  }
}

</script>

<style scoped lang="less">
.hp-title {
  padding-top: 15px;
  padding-bottom: 15px;
}

.hp-title div {
  height: 18px;
  border-left: 5px solid dodgerblue;
  width: 15px;
  display: inline-block;
}

.hp-title span {
  font-size: 16px;
  font-weight: bold
}
</style>
